module.exports = __webpack_public_path__ + "img/AT0000002567228.5cc531fb.png";